import {
	ChangeDetectionStrategy,
	Component
} from '@angular/core';

@Component({
	selector: 'go-logo',
	templateUrl: './go-logo.component.html',
	styleUrls: ['./go-logo.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class GoLogoComponent {
	constructor () {}
}
